import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import BalancoService from '../../../../../services/balanco-auth';
import { Link } from 'react-router-dom';



const FormBusca = (props) => {
    const [fundo, setFundo] = useState("");
    const [tipo, setTipo] = useState("");
    const [ano, setAno] = useState("");



    const busca = async (query) => {
        if (query == "") {
            props.setAindaTem(true)
            await props.fetchBalancosIn()
            setAno("")
            setFundo("")
            setTipo("")
        } else {
            var response = await BalancoService.buscar(query)
            if (response.data.length >= 1) {
                props.setBalancos(response.data)
                props.setAindaTem(false)
                props.setVazio(false)
                setAno("")
                setFundo("")
                setTipo("")
            } else {
                props.setVazio(true)
                setAno("")
                setFundo("")
                setTipo("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (fundo !== "false" && fundo !== "") prepQuery = prepQuery + `&fundo=${fundo}`;
        if (tipo !== "false" && tipo !== "") prepQuery = prepQuery + `&tipo=${tipo}`;
        if (ano !== "false" && ano !== "") prepQuery = prepQuery + `&ano=${ano}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={1} lg={4}>
                            <Form.Group className="mb-3" controlId="fundo">
                                <FloatingLabel
                                    label="Fundo do Balanço"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="fundo"
                                        name="fundo"
                                        onChange={e => setFundo(e.target.value)}
                                    >
                                        <option value="false">TODOS</option>
                                        <option value="Consolidado">Consolidado</option>
                                        <option value="Fundo Municipal de Assistência Social">Fundo Municipal de Assistência Social</option>
                                        <option value="Fundo Municipal de Habitação">Fundo Municipal de Habitação</option>
                                        <option value="Fundo Municipal de Meio Ambiente">Fundo Municipal de Meio Ambiente</option>
                                        <option value="Fundo Municipal de Saúde">Fundo Municipal de Saúde</option>
                                        <option value="Fundo Municipal de Educação">Fundo Municipal de Educação</option>
                                        <option value="Fundo Municipal dos Direitos da Criança e dos Adolescentes">Fundo Municipal dos Direitos da Criança e dos Adolescentes</option>
                                        <option value="Prefeitura Municipal">Prefeitura Municipal</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={1} lg={4}>
                            <Form.Group className="mb-3" controlId="tipo">
                                <FloatingLabel
                                    label="Tipo do Balanço"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="tipo"
                                        name="tipo"
                                        onChange={e => setTipo(e.target.value)}
                                    >
                                        <option value="false">TODOS</option>
                                        <option value="Financeiro">Financeiro</option>
                                        <option value="Orçamentário">Orçamentário</option>
                                        <option value="Patrimonial">Patrimonial</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={1} lg={2}>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option value="false">TODOS</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2026">2026</option>
                                        
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>

                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/restrito/balanco'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca